import { render, staticRenderFns } from "./share-data.vue?vue&type=template&id=0a483a8c&scoped=true&"
import script from "./share-data.vue?vue&type=script&lang=js&"
export * from "./share-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a483a8c",
  null
  
)

export default component.exports